import { Inject, Injectable } from '@angular/core';
import { MemberPlot } from './models/member-plot.model';
import { ApiService } from '../../shared/services/api.service';
import { API_BASE_URL } from '../../shared/tokens/api.tokens';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs';
import { ResultSet } from '../../shared/models/result-set.model';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class MemberPlotsService extends ApiService<MemberPlot> {

  override readonly _baseUrl: string;

  override readonly searchFields = [];

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}members/plots/`;    
  }

  getPlotsForMember(memberId: number, offset: number = 0, limit: number = 10) {
    const params = new HttpParams()
      .set('offset', offset.toString())
      .set('limit', limit.toString());
    return this.http.get<ResultSet<MemberPlot>>(`${this._baseUrl}for-member/${memberId}`,{ params }).pipe(
          catchError(this.handleError)
        );
  }
}
